import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import CalcularReceitasIcon from '../assets/iconReceitas.png';
import {
  ArrowLeftOutlined,
  BookOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';
import './CalcularReceitas.scss';
import { useNavigate } from 'react-router-dom'
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { v4 as uuidv4 } from 'uuid';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { createRecipe, getRecipe, createRefInDay, exportTableRecipe, deleteRecipe} from '../service/api';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AddIcon from '@mui/icons-material/Add';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll',
};

const CalcularReceitas = () => {
  let navigate = useNavigate();
  const [recipes, setRecipes] = useState([])
  const [selectingRecipes, setSelectingRecipes] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [openModalPieces, setOpenModalPieces] = useState(false)
  const [openModalTabela, setOpenModalTabela] = useState(false)

  const [recipeSelected, setRecipeSelected] = useState(
    {
      recipeName: "",
      alimentos: [],
      preparationMethod: '',
      prieces: '',
      gramsPiece: ''
    }
  )
  const [openNewRecipeModal, setOpenNewRecipeModal] = useState(false)
  const [recipeName, setRecipeName] = useState("")
  const [howToDo, setHowToDo] = useState("")
  const [porcoes, setPorcoes] = useState("")
  const [qntPorPorcoes, setQntPorPorcoes] = useState("")
  const [ingredientes, setIngredientes] = useState([])
  const [open, setOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [userId, setUserId] = useState("");
  const [tableData, setTableData] = useState([])
  const [openTabela, setOpenTable] = useState(false)
  const [partsOnRecipe, setPartsOnRecipe] = useState(1)
  const [age, setAge] = React.useState('');
  const [recipeToInsert, setRecipeToInsert] = useState({})

  const handleChangePieces = (event) => {
    setAge(event.target.value);
  };

  let { day } = useParams();
  let { ref } = useParams();
  let { recipeId } = useParams();

  useEffect(() => {
    console.log('RECIPES')
    const userId = localStorage.getItem('userId')
    setUserId(userId)
    if (!userId) {
      navigate('/login', { replace: true })
    }

    const loadRecipes = async (userId) => {
      console.log("load recipes")
      await getRecipe(userId)
        .then(response => {
          if (response)
            if (response.length > 0)
              setRecipes(response)
        })
        .catch(function (error) {
          console.log(error)
        });
    }
    loadRecipes(userId)

    // var recipesStorage = localStorage.getItem('recipes')
    // recipesStorage = JSON.parse(recipesStorage)
    // console.log(recipesStorage)
    // if (recipesStorage != null) {
    //   if (recipesStorage.length > 0)
    //     console.log(recipesStorage.length)
    //     setRecipes(recipesStorage)
    // }
    if (recipeId) {
      const newRecipe = JSON.parse(localStorage.getItem(recipeId))
      setRecipeName(newRecipe.nome)
      setHowToDo(newRecipe.how)
      setPorcoes(newRecipe.porcoes)
      setQntPorPorcoes(newRecipe.qntPorPorcoes)
      setIngredientes(newRecipe.alimentos)
      setOpenNewRecipeModal(true)
    }
    if (day)
      setSelectingRecipes(true)
  }, [])

  const onClickBack = () => {
    console.log("click")
    navigate('/', { replace: true });
  }

  const deleteRecipeAction = async (r) => {
    await deleteRecipe(r.recipeId)
      .then(response => {
        window.location.reload()
      })
      .catch(function (error) {
        console.log(error)
        setErrorMessage("Erro ao deletar receita, tente novamente")
        setOpen(true)
      });
  }

  const registrarAlimentos = async (itens) => {
    console.log(itens)
    const date = new Date
    var userId = localStorage.getItem("userId");
    const dayonWeeks = {
      'dom': 0,
      'seg': 1,
      'ter': 2,
      'qua': 3,
      'qui': 4,
      'sex': 5,
      'sab': 6
    }
    let dateSelected = (date.getDate() - date.getDay()) + dayonWeeks[day];
    dateSelected = new Date(date.setDate(dateSelected)).toISOString();
    let alimentos = []
    var parts = 1
    if (itens.pieces != "") {
      parts = parseInt(itens.pieces)
    }
    itens.alimentos.map(function (item, i) {
      console.log(parts)
      console.log(age)

      var quantidadePieces = (item.quantidade / parts) * age
      const obj = {
        alimentoid: item.alimentoId,
        quantidade: quantidadePieces
      }
      alimentos.push(obj)
    })
    await createRefInDay(alimentos, dateSelected, userId, ref)
      .then(response => {
        if (response) {
          navigate('/diario', { replace: true });
        }
      }).catch(error => {
        console.log(error)
        setErrorMessage("Erro ao inserir receita, tente novamente mais tarde")
        setOpen(true)
      })

    //navigate('/diario', { replace: true });

  }

  const handleOpenModal = (recipe) => {
    console.log(recipe)
    setRecipeSelected(recipe)
    setOpenModal(true)
  }

  const handleOpenModalPieces = (recipe) => {
    console.log(recipe)
    setRecipeToInsert(recipe)
    setOpenModalPieces(true)
  }

  const handleOpenModalTabela = () => {
    setOpenModalTabela(true)
  }
  const handleCloseTable = () => {
    setOpenModalTabela(false)
  }
  const handleClose = () => {
    setRecipeSelected({
      recipeName: "",
      alimentos: [],
      preparationMethod: '',
      prieces: '',
      gramsPiece: ''
    })
    setOpenModal(false)
  }

  const handleClosePieces = () => {
    setOpenModalPieces(false)
  }

  const handleCloseNewRecipe = () => {
    setRecipeName("")
    setHowToDo("")
    setPorcoes("")
    setQntPorPorcoes("")
    setIngredientes([])
    setOpenNewRecipeModal(false)
  }

  const handleOpenNewRecipeModal = () => {
    setOpenNewRecipeModal(true)
  }

  const handleChange = (value, state) => {
    state(value)
  }

  const onClickSearch = () => {
    const uuid = uuidv4();
    const data = {
      id: uuid,
      nome: recipeName,
      how: howToDo,
      porcoes,
      qntPorPorcoes,
      alimentos: ingredientes
    }
    localStorage.setItem(uuid, JSON.stringify(data))
    navigate(`/consultar-alimentos/${uuid}`, { replace: true });
  }

  // {
  //   "userId": "9e4bbec0-1711-4365-a458-1c9019a869f9",
  //   "name": "Teste2",
  //   "preparation": "Modo de preparo Teste2",
  //   "pieces": "2",
  //   "gramsPiece": "20",
  //   "alimentos": [
  //     {
  //       "alimentoid": "d82f93b0-ff55-4a28-b05a-90925d410397",
  //       "nome": "Morango, in natura",
  //       "quantidade": 100
  //     },
  //     {
  //       "alimentoid":"ac982671-504f-4ce4-aaaf-62c5087f60f2",
  //       "nome": "Grão de bico, cru",
  //       "quantidade": 50
  //     }
  //   ]
  // }

  const onClickSave = async () => {
    if (ingredientes.length > 0) {
      const data = {
        userId: userId,
        name: recipeName,
        preparation: howToDo,
        pieces: porcoes,
        gramsPiece: qntPorPorcoes,
        alimentos: ingredientes
      }
      var aux = []
      if (recipes.length > 0)
        aux = recipes
      console.log(recipes)
      aux.push(data)
      console.log(aux)
      const newRecipes = aux
      //setRecipes(newRecipes)
      await createRecipe(data)
        .then(response => {
          if (response) {
            handleCloseNewRecipe()
            navigate('/calcular-receitas', { replace: true });
            window.location.reload(false);
          }
        }).catch(error => {
          console.log(error)
          setErrorMessage("Erro ao criar receita, tente novamente mais tarde")
          setOpen(true)
        })
      //localStorage.setItem("recipes", JSON.stringify(newRecipes))
    } else {
      setErrorMessage("Adicione ingredientes a receita")
      setOpen(true)
    }
  }

  const calculatePartsGrams = (parts, grams) => {
    const result = (grams / parts).toFixed(2)
    return result
  }

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const loadTabelaNutricional = async () => {
    var table = []
    var porcao = ""
    console.log(recipeSelected)
    // if (recipeSelected.pieces != null && recipeSelected.pieces != "") {
    //   if (recipeSelected.gramsPiece != null && recipeSelected.gramsPiece != "") {
    //     porcao = ecipeSelected.gramsPiece
    //   } else {

    //   }
    // } else {
    var parts = 1
    if (recipeSelected.pieces != "") {
      parts = recipeSelected.pieces
      setPartsOnRecipe(parts)
    }
    const data = {
      calcio: 0,
      carboidrato: 0,
      cistina: 0,
      energia: 0,
      fenilanina: 0,
      fibras: 0,
      isoleucina: 0,
      leucina: 0,
      lipidios: 0,
      lisina: 0,
      metionina: 0,
      proteina: 0,
      tirosina: 0,
      treonina: 0,
      valina: 0,
      vitb12: 0,

    }
    var count = 0

    recipeSelected.alimentos.forEach(async (element) => {
      count++
      console.log(element)
      if (!isNaN(parseFloat(element.calcio))) {
        const grams = ((parseFloat(element.calcio) * parseFloat(element.quantidade)) / 100) + parseFloat(data.calcio)
        data.calcio = grams
      }
      if (!isNaN(parseFloat(element.carboidrato))) {
        const grams = ((parseFloat(element.carboidrato) * parseFloat(element.quantidade)) / 100) + parseFloat(data.carboidrato)
        data.carboidrato = grams
      }
      if (!isNaN(parseFloat(element.cistina))) {
        const grams = ((parseFloat(element.cistina) * parseFloat(element.quantidade)) / 100) + parseFloat(data.cistina)
        data.cistina = grams
      }
      if (!isNaN(parseFloat(element.energia))) {
        const grams = ((parseFloat(element.energia) * parseFloat(element.quantidade)) / 100) + parseFloat(data.energia)
        data.energia = grams
      }
      if (!isNaN(parseFloat(element.fenilanina))) {
        const grams = ((parseFloat(element.fenilanina) * parseFloat(element.quantidade)) / 100) + parseFloat(data.fenilanina)
        data.fenilanina = grams
      }
      if (!isNaN(parseFloat(element.isoleucina))) {
        const grams = ((parseFloat(element.isoleucina) * parseFloat(element.quantidade)) / 100) + parseFloat(data.isoleucina)
        data.isoleucina = grams
      }
      if (!isNaN(parseFloat(element.leucina))) {
        const grams = ((parseFloat(element.leucina) * parseFloat(element.quantidade)) / 100) + parseFloat(data.leucina)
        data.leucina = grams
      }
      if (!isNaN(parseFloat(element.lipidios))) {
        const grams = ((parseFloat(element.lipidios) * parseFloat(element.quantidade)) / 100) + parseFloat(data.lipidios)
        data.lipidios = grams
      }
      if (!isNaN(parseFloat(element.lisina))) {
        const grams = ((parseFloat(element.lisina) * parseFloat(element.quantidade)) / 100) + parseFloat(data.lisina)
        data.lisina = grams
      }
      if (!isNaN(parseFloat(element.metionina))) {
        const grams = ((parseFloat(element.metionina) * parseFloat(element.quantidade)) / 100) + parseFloat(data.metionina)
        data.metionina = grams
      }
      if (!isNaN(parseFloat(element.proteina))) {
        const grams = ((parseFloat(element.proteina) * parseFloat(element.quantidade)) / 100) + parseFloat(data.proteina)
        data.proteina = grams
      }
      if (!isNaN(parseFloat(element.tirosina))) {
        const grams = ((parseFloat(element.tirosina) * parseFloat(element.quantidade)) / 100) + parseFloat(data.tirosina)
        data.tirosina = grams
      }
      if (!isNaN(parseFloat(element.treonina))) {
        const grams = ((parseFloat(element.treonina) * parseFloat(element.quantidade)) / 100) + parseFloat(data.treonina)
        data.treonina = grams
      }
      if (!isNaN(parseFloat(element.valina))) {
        const grams = ((parseFloat(element.valina) * parseFloat(element.quantidade)) / 100) + parseFloat(data.valina)
        data.valina = grams
      }
      if (!isNaN(parseFloat(element.vitb12))) {
        const grams = ((parseFloat(element.vitb12) * parseFloat(element.quantidade)) / 100) + parseFloat(data.vitb12)
        data.vitb12 = grams
      }
      if (!isNaN(parseFloat(element.fibras))) {
        const grams = ((parseFloat(element.fibras) * parseFloat(element.quantidade)) / 100) + parseFloat(data.fibras)
        data.fibras = grams
      }
      if (count >= recipeSelected.alimentos.length) {
        table.push(
          {
            nutriente: "Valor Energético (kcal)",
            field: "calorias",
            quantidade: calculatePartsGrams(parts, data.energia)
          }
        )
        table.push(
          {
            nutriente: "calcio",
            field: "calcio",
            quantidade: calculatePartsGrams(parts, data.calcio)
          }
        )
        table.push(
          {
            nutriente: "carboidrato",
            field: "carbo",
            quantidade: calculatePartsGrams(parts, data.carboidrato)
          }
        )
        table.push(
          {
            nutriente: "cistina",
            field: "cistina",
            quantidade: calculatePartsGrams(parts, data.cistina)
          }
        )
        table.push(
          {
            nutriente: "fenilalanina",
            field: "fenilalanina",
            quantidade: calculatePartsGrams(parts, data.fenilanina)
          }
        )
        table.push(
          {
            nutriente: "isoleucina",
            field: "isoleucina",
            quantidade: calculatePartsGrams(parts, data.isoleucina)
          }
        )
        table.push(
          {
            nutriente: "leucina",
            field: "leucina",
            quantidade: calculatePartsGrams(parts, data.leucina)
          }
        )
        table.push(
          {
            nutriente: "lipidios",
            field: "lipideos",
            quantidade: calculatePartsGrams(parts, data.lipidios)
          }
        )
        table.push(
          {
            nutriente: "lisina",
            field: "lisina",
            quantidade: calculatePartsGrams(parts, data.lisina)
          }
        )
        table.push(
          {
            nutriente: "metionina",
            field: "metionina",
            quantidade: calculatePartsGrams(parts, data.metionina)
          }
        )
        table.push(
          {
            nutriente: "proteina",
            field: "proteina",
            quantidade: calculatePartsGrams(parts, data.proteina)
          }
        )
        table.push(
          {
            nutriente: "tirosina",
            field: "tirosina",
            quantidade: calculatePartsGrams(parts, data.tirosina)
          }
        )
        table.push(
          {
            nutriente: "treonina",
            field: "treonina",
            quantidade: calculatePartsGrams(parts, data.treonina)
          }
        )
        table.push(
          {
            nutriente: "valina",
            field: "valina",
            quantidade: calculatePartsGrams(parts, data.valina)
          }
        )
        table.push(
          {
            nutriente: "vitb12",
            field: "vit",
            quantidade: calculatePartsGrams(parts, data.vitb12)
          }
        )
        table.push(
          {
            nutriente: "fibras",
            field: "fibras",
            quantidade: calculatePartsGrams(parts, data.fibras)
          }
        )

        const body = {
          pieces: parts,
          nome: recipeSelected.recipeName,
          table: table
        }
        await exportTableRecipe(body).then(response => {
          const fileLink = document.createElement('a');
          fileLink.href = response.fileURL;
          const fileName = response.fileName;
          fileLink.setAttribute('download', fileName);
          fileLink.setAttribute('target', '_blank');
          document.body.appendChild(fileLink);
          fileLink.click();
          fileLink.remove();
        }).catch(error => {
          console.log(error)
          setErrorMessage(error)
          setOpen(true)
        });
        console.log(table)
        // setTableData(table)
        // setOpenTable(true)
        // setOpenModalTabela(true)
      }
    })
    // }
  }


  return (
    <div className='receitas'>
      <Row>
        <Col span={24} className='receitas__header'>
          <ArrowLeftOutlined className='receitas__icons' onClick={onClickBack} />
          <img src={CalcularReceitasIcon} alt='' className='receitas__logo' />
          <p className='receitas__title'>Calcular Receitas</p>
        </Col>
      </Row>
      <div>
        {
          recipes.length > 0 ?
            <div className="receitas__cadastro">
              <div className="receitas__cadastroTitle">Suas Receitas</div>
              {
                recipes.map(function (recipe, i) {
                  return (
                    <div>
                      <div className="receitas__grid-item" onClick={selectingRecipes ? () => handleOpenModalPieces(recipe) : () => handleOpenModal(recipe)}>
                        <div className="receitas__itemDescription">{recipe.recipeName}</div>
                      </div>
                      {
                        !selectingRecipes ?
                          <div className="receitas__exclud" onClick={() => deleteRecipeAction(recipe)}>
                            <DeleteIcon />
                          </div>
                          :
                          <div className="receitas__exclud" onClick={() => handleOpenModalPieces(recipe)}>
                            <AddIcon />
                          </div>
                      }
                    </div>
                  )
                })
              }
            </div>
            :
            <div className="receitas__cadastro" style={{ marginTop: 10 }}>
              Você não possui receitas ainda
            </div>
        }
      </div>
      {
        !selectingRecipes &&
        <div className='receitas__cardSearch' onClick={() => handleOpenNewRecipeModal()}>
          <BookOutlined style={{ marginRight: 10 }} />
          Criar nova receita
        </div>
      }

      <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert>
      </Snackbar>

      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ overflow: 'scroll' }}
      >
        <Box sx={style}>
          {
            recipeSelected != undefined &&
            <div className="receitas__recipeDescription">
              <h2>{recipeSelected.recipeName}</h2>

              <h3>Ingredientes:</h3>
              {
                recipeSelected.alimentos.map(function (dish, i) {
                  return (
                    <div style={{ fontSize: 14, marginBottom: 10 }}>
                      <b>- {dish.alimentoName}</b>: {dish.quantidade}g
                    </div>
                  )
                })}
              <p style={{ fontSize: 12 }}><b>Modo de preparo:</b> {recipeSelected.preparationMethod}</p>
              <p style={{ fontSize: 12 }}><b>Rende quantas porções:</b> {recipeSelected.pieces}</p>
              <p style={{ fontSize: 12 }}><b>Gramagem por porções:</b> {recipeSelected.gramsPiece}g</p>
              <div className='receitas__cardSearch' onClick={() => loadTabelaNutricional()}>
                Tabela nutricional
              </div>
              <a href="" download=""></a>
            </div>
          }

        </Box>
      </Modal>

      <Modal
        open={openModalPieces}
        onClose={handleClosePieces}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ overflow: 'scroll' }}
      >
        <Box sx={style}>
          <h2>Quantas porções foram consumidas?</h2>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Porções</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={age}
              label="Age"
              onChange={handleChangePieces}
            >
              {
                recipeToInsert.pieces &&
                [...Array(parseInt(recipeToInsert.pieces))].map((x, i) =>
                  <MenuItem value={i + 1}>{i + 1}</MenuItem>
                )
              }
            </Select>
          </FormControl>
          {
            age != '' &&
            <div className='receitas__cardSearch' onClick={() => registrarAlimentos(recipeToInsert)}>
              Inserir Receita ao Diário
            </div>
          }
        </Box>
      </Modal>

      <Modal
        open={openModalTabela}
        onClose={handleCloseTable}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ overflow: 'scroll' }}
      >
        <Box sx={style}>
          {

            <div className='receitas__table'>
              <h2>Tabela Nutricional</h2>
              <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nutriente</TableCell>
                      <TableCell align="right">Gramagem para {partsOnRecipe} {partsOnRecipe > 1 ? "porções" : "porção"}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.map((row) => (
                      <TableRow
                        key={row.nutriente}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {row.nutriente}
                        </TableCell>
                        <TableCell align="right">{row.quantidade}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

          }

        </Box>
      </Modal>

      <Modal
        open={openNewRecipeModal}
        onClose={handleCloseNewRecipe}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ overflow: 'scroll' }}
      >
        <Box sx={style}>
          <div className="receitas__newRecipe">
            <h3><b>Nova Receita</b></h3>
            <div className='receitas__formPass'>
              <TextField fullWidth defaultValue={recipeName} onChange={(event) => handleChange(event.target.value, setRecipeName)} id="outlined-basic" label="Nome da receita" variant="outlined" className='login__emailField' />
            </div>
            <div className='receitas__cardSearch' onClick={() => onClickSearch()}>
              Adicionar ingredientes a receita
            </div>
            {
              ingredientes.length > 0 &&
              <p><b>Ingredientes adicionados a receita</b></p>
            }
            <div className='receitas__ingredientes'>
            {
              ingredientes.map(function (alimentos, i) {
                return (
                  <p>- {alimentos.nome}: {alimentos.quantidade}g</p>
                )
              })
            }
            </div>
            <div className='receitas__formPass'>
              <TextField fullWidth maxRows={4} defaultValue={howToDo} onChange={(event) => handleChange(event.target.value, setHowToDo)} id="outlined-multiline-flexible" multiline label="Modo de Preparo" variant="outlined" className='login__emailField' />
            </div>
            <div className='receitas__formPass'>
              <TextField fullWidth defaultValue={porcoes} onChange={(event) => handleChange(event.target.value, setPorcoes)} id="outlined-basic" label="Quantas porções rende a receita" variant="outlined" className='login__emailField' />
            </div>
            <div className='receitas__formPass'>
              <TextField fullWidth defaultValue={qntPorPorcoes} onChange={(event) => handleChange(event.target.value, setQntPorPorcoes)} id="outlined-basic" label="Gramagem por porção" variant="outlined" className='login__emailField' />
            </div>
            <div className='receitas__cardSearch' onClick={() => onClickSave()}>
              Salvar Receita
            </div>
          </div>

        </Box>
      </Modal>
    </div>
  )
}

export default CalcularReceitas
